import './style.modules.scss'

import { VideoDescription, VideoPlayer } from '@ampcore/video-player'
import { AnalyticsTagBuilder } from '@dai-team/analytics-library'
import React from 'react'
import xss from 'xss'

import type { VideoCardProps } from './VideoCardRecord.type'

export const VideoCard: React.FC<VideoCardProps> = ({ card }) => {
  const {
    playlistId = '',
    videoId = '',
    cardSuperHeadline = '',
    cardHeading = '',
    cardDescription = '',
    cardPublicationDate = ''
  } = card
  const hasContent = cardHeading || cardDescription
  const atb = new AnalyticsTagBuilder().setDefaultName('ArticleCard')
  return (
    <div
      className={`VideoCard VideoCard-Border VideoCard--redesign u-flex u-flexCol u-paddingBottom20 u-posRelative u-bgColorWhite u-sizeFull
        }`}
      {...atb.dataAnalyticAttribute()}
    >
      <div className="VideoCard-image">
        <VideoPlayer
          accountId={window.BRIGHTCOVE_ACC || ''}
          policyKey={window.BRIGHTCOVE_PK || ''}
          playlistId={playlistId}
          videoId={videoId}
        />
      </div>
      <div className="VideoCard-body card-content u-paddingHoriz20 u-paddingVert20">
        {cardSuperHeadline && (
          <h5 className="u-textColorLight u-textSizeMsrm1 u-textUppercase">
            {cardSuperHeadline}
          </h5>
        )}
        {hasContent ? (
          <>
            {cardHeading && (
              <h4 className="VideoCard-heading u-paddingVert8 u-textColorNeutralGrey">
                <strong>{cardHeading}</strong>
              </h4>
            )}
            {cardDescription && (
              <div
                className="VideoCard-description"
                dangerouslySetInnerHTML={{ __html: xss(cardDescription || '') }}
              />
            )}
          </>
        ) : (
          <VideoDescription
            className="video-container Content"
            accountId={window.BRIGHTCOVE_ACC || ''}
            policyKey={window.BRIGHTCOVE_PK || ''}
            playlistId={playlistId}
            videoId={videoId}
          />
        )}
      </div>
      {cardPublicationDate && (
        <div className="u-sizeFull u-paddingHoriz20">
          <p className="u-textColorLight u-textSizeMsrm1">
            {cardPublicationDate}
          </p>
        </div>
      )}
    </div>
  )
}
